<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 8H42C43.1046 8 44 8.89543 44 10V38C44 39.1046 43.1046 40 42 40H6C4.89543 40 4 39.1046 4 38V10C4 8.89543 4.89543 8 6 8ZM32.3872 29.6376C31.0912 31.02 29.212 31.7112 26.728 31.7112H21.1552V16.2888H26.7712C29.2552 16.2888 31.1344 16.98 32.4304 18.384C33.64 19.68 34.2448 21.5592 34.2448 24C34.2448 26.4192 33.6184 28.2984 32.3872 29.6376ZM18.088 16.2889V31.7113H15.7552V16.2889H18.088ZM26.2947 29.7022H23.5083V18.2974H26.3379C28.2819 18.2974 29.7075 18.751 30.6147 19.6798C31.4787 20.587 31.9323 22.0126 31.9323 23.9998C31.9323 25.9438 31.4787 27.3694 30.5931 28.2982C29.6859 29.227 28.2387 29.7022 26.2947 29.7022Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
